var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swipe-wrapper"},[_c('div',{staticClass:"back"},[_c('i',{staticClass:"iconfont icon-jiantou"}),_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("请点击屏幕右上角 [ ··· ]")]),_c('p',[_vm._v(" 在 "),_c('i',{staticClass:"iconfont icon-browser"}),_vm._v(" 浏览器打开 ")])])])
}]

export { render, staticRenderFns }